import { render, staticRenderFns } from "./attributeDialog.vue?vue&type=template&id=441a22e2&scoped=true"
import script from "./attributeDialog.vue?vue&type=script&lang=js"
export * from "./attributeDialog.vue?vue&type=script&lang=js"
import style0 from "./attributeDialog.vue?vue&type=style&index=0&id=441a22e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441a22e2",
  null
  
)

export default component.exports